import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

const AppointmentsScreen = lazy(() => import('../screens/AppointmentsScreen.js'));

/** « Rendez-vous » (03/10/2026) : arrivées prévues, groupées par jour (route `/rendez-vous`). */
export default function AppointmentsPage() {
  return (
    <GarageGate>
      <AppointmentsScreen />
    </GarageGate>
  );
}
